import React from 'react';
import styled from 'styled-components';
import AdminLayout from 'Components/Layout/AdminLayout';
import AdminMessagesComponent from 'Components/AdminPage/AdminMessages';

const ContentContainer = styled.div`
  width: 100%;
  margin: 20px;
  overflow: auto;
  flex: 1;
`;

const AdminMessages = () => {
  return (
    <AdminLayout>
      <ContentContainer>
        <AdminMessagesComponent />
      </ContentContainer>
    </AdminLayout>
  );
};
export default AdminMessages;
